<template>
  <div id="app" :class="osClassname">
    <!-- FIXME -->
    <router-view />

    <!-- 这里不能直接用a-spin包裹router-view，不然宽高会出现问题 -->
    <div v-show="loading" class="app-spin-wrapper">
      <div class="app-spin-blur" :style="{ opacity: loading ? 0.5 : 0 }" />
      <a-spin :tip="tip">
        <a-icon slot="indicator" type="loading" style="font-size: 50px" spin />
      </a-spin>
    </div>

    <!--
      AI Assistant：全局挂载，iframe 内不显示（self !== parent）。
      data-spm-page：声明 AI 面板内所有 iht 埋点的 page 层级 code；
      属性会被 Vue 自动透传到 controller 根节点 .ai-controller，
      iht 从 tracker.track 传入的 DOM 向上查找即可定位到该 page 节点。
    -->
    <AIAssistantController
      v-if="isMerchant && !isInIframe"
      data-spm-page="AIAssistant"
      shrink-target="#app"
    />

    <!--
      AI 改价自动提交审核的常驻宿主：挂在 App 顶层是因为页面内的 Submit cost 入口
      会随保存成功后的抽屉关闭/reloadPage 重挂而销毁，workflow tool 必须常驻。
      workflow 在 iframe 内执行，故不加 isInIframe 限制。
    -->
    <AiSubmitCostHost v-if="isMerchant" />

    <!-- 批量 workflow 辅助工具的常驻宿主（信号预备/等待结果/不支持项拒绝），同样常驻 App 顶层 -->
    <AiBatchHost v-if="isMerchant" />
  </div>
</template>

<script>
import { AIAssistantController } from '@klook/admin-ai-assistant'
import { isMerchant } from '@/env'

export default {
  components: {
    AIAssistantController,
    // 两个 AI 宿主必须异步加载：它们间接引入 ajax.js，而 ajax.js 模块顶层依赖
    // window.__（plugins/i18n.js 初始化后才挂载）。静态 import 会把 ajax.js 拉进
    // 主入口同步模块图，先于 registerPlugins 执行导致 "__ is not defined"。
    // 异步组件在 createApp 渲染时才加载，此时插件已全部就绪。
    AiSubmitCostHost: () => import('@/plugins/ai-assistant/AiSubmitCostHost.vue'),
    AiBatchHost: () => import('@/plugins/ai-assistant/AiBatchHost.vue')
  },
  provide() {
    return {
      rootChangeLoading: this.changeLoading
    }
  },
  data() {
    return {
      // AI Assistant 仅 merchant 端启用；admin 后端无 agent/init 接口，挂载即报 405
      isMerchant,
      loading: false,
      tip: ''
    }
  },
  computed: {
    isInIframe() {
      try {
        return window.self !== window.top
      } catch (e) {
        return true
      }
    },
    osClassname() {
      const agent = navigator.userAgent.toLowerCase()
      const isMac = /macintosh|mac os x/i.test(navigator.userAgent)
      if (agent.indexOf('win32') >= 0 || agent.indexOf('wow32') >= 0) {
        return ['is-windows-os', 'is-32-bit-sys']
      }
      if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
        return ['is-windows-os', 'is-64-bit-sys']
      }
      if (isMac) {
        return ['is-mac-os']
      }

      return []
    }
  },
  created() {
    window.setLoading2root = this.changeLoading
  },
  methods: {
    changeLoading(isLoading = false, tip = '') {
      this.tip = tip
      this.loading = isLoading
    }
  }
}
</script>
<style lang="scss">
@import './assets/css/lib/common.scss';

.app-spin-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;

  .app-spin-blur {
    width: 100%;
    height: 100%;
    user-select: none;
    pointer-events: none;
    overflow: hidden;
    transition: opacity 0.3s;
    background: #fff;
  }

  .ant-spin {
    position: absolute;
    left: 55%;
    top: 40%;
    transform: translateX(-50%) translateY(-50%);
  }

  .main-container-subSidebar {
    z-index: 11;
    .subSidebar-menu {
      background-color: #235baf;
    }
  }
}
</style>
